// extracted by mini-css-extract-plugin
export default {"heading":"_1p19h","content":"K42IE"};